import React from "react";
import { stylex } from "./stylex";
import { cssVariables } from "./css_variables";
import { Text } from "./text";
import { Icon, IconName } from "./icon";
import { Spacing } from "./spacing";
import { Container } from "./container";

interface PickerDisplayProps {
  title?: string;
  component?: React.ReactNode;
  iconBefore?: IconName;
  disabled?: boolean;
  invalid?: boolean;
  wrapperStyles?: React.CSSProperties;
  showArrow?: boolean;
}

/**
 * A button commonly used for call-to-actions.
 */
export function PickerDisplay(props: PickerDisplayProps) {
  const {
    title,
    component,
    iconBefore,
    disabled,
    invalid,
    wrapperStyles,
    showArrow = true,
  } = props;

  return (
    <div
      style={{
        ...styles("root", disabled && "disabled", invalid && "invalid"),
        ...(wrapperStyles || {}),
      }}
    >
      {iconBefore && (
        <>
          <Container center width={30} height={30}>
            <Icon name={iconBefore} color={cssVariables.textColorMuted} />
          </Container>
          <Spacing width={8} />
        </>
      )}
      {component || (
        <Text
          overflow="ellipsis"
          color={invalid ? "error" : disabled ? "muted" : "default"}
        >
          {title}
        </Text>
      )}
      {showArrow && (
        <div style={styles("arrow")}>
          <Icon name="chevron-down" size={18} />
        </div>
      )}
    </div>
  );
}

const styles = stylex.create({
  root: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    boxShadow: "none",
    boxSizing: "border-box",
    background: "none",
    backgroundColor: "white",
    paddingLeft: 8,
    position: "relative",
    paddingRight: 40,
    borderRadius: cssVariables.radius,
    height: 40,
    cursor: "pointer",
    textDecoration: "none",
    border: `1px solid ${cssVariables.borderColorDark}`,
    width: "100%",
  },
  arrow: {
    position: "absolute",
    right: 8,
    top: 0,
    boxSizing: "border-box",
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  disabled: {
    cursor: "auto",
    boxShadow: "inset 0 0 490px rgba(0, 0, 0, 0.03)",
  },
  invalid: {
    border: `1px solid ${cssVariables.borderColorDanger}`,
  },
});
